import styled from 'styled-components';
import { CarOptionStyled } from '../CarOptionStyled';
import { rem } from 'polished';

export const CarOptionStyledAC = styled(CarOptionStyled)`
    border-radius: ${rem(12)};

    &.isSelected {
        background: rgba(157, 199, 224, 0.2);
        border-color: ${({ theme }) => theme.colors.blue2};
        .inner {
            border-color: ${({ theme }) => theme.colors.blue2};
            border-radius: ${rem(10)};
        }
    }

    &:hover,
    &:focus-visible {
        border: 1px solid ${({ theme }) => theme.colors.blue2};
        .inner {
            border: 1px solid ${({ theme }) => theme.colors.blue2};
            border-radius: ${rem(10)};
        }
    }

    .option-card {
        &__name {
            color: ${({ theme }) => theme.colors.grey5};
            font-size: ${({ theme }) => theme.fontSizes.h4};
        }
        &__add-priceWrapper {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
        }
        &__wrap {
            .link {
                .linkText {
                    margin-top: ${rem(20)};
                    color: ${({ theme }) => theme.colors.grey5};
                    font-size: ${({ theme }) => theme.fontSizes.h5};
                }
            }
        }
        &__detailDescription {
            color: ${({ theme }) => theme.colors.grey5};
            line-height: ${rem(18)};
        }
    }
`;
